define('app/views/grouped_product_view',['app/setup'], function(takhfifan) {

  takhfifan.GroupedProductView = Backbone.View.extend({
    tagName: 'li',
    events: {
      'click .btn': 'submit'
    },

    initialize: function(options) {
      _.bindAll(this, 'render');
      this.render();

      var _this = this;
      this.parentProductId = options.parentProductId;
      this.parentEl = options.parentEl;
      this.generateAddToCartForm();
      this.model.on('change', this.render, this);

      takhfifan.eventHub.on('timeover:' + this.parentProductId, function() {
        _this.disable();
        _this.setAsDeactive();
      }, this);

      takhfifan.eventHub.on('groupedProduct:removeAssociate',
        function(opts) {
          if(_this.model.id===opts.productId) {
            _this.disable();
            _this.setAsDeactive();
          }
      }, this);
    },

    render:function(){
      this.$el.empty();
      var template = _.template($('#tkh-template-grouped-child-item').html()),
          result = template(this.model.attributes);
      this.$el.addClass('tkh-grouped-product').append(result);

      return this;
    },

    generateAddToCartForm: function() {
      var $form = $('<form />').prop({
        method: 'post',
        action: '#'
      }).css('display', 'none');

      this.parentEl.append($form);
      new takhfifan.AddToCartFormView({el: $form, productId: this.model.id});

      //model already fetched...
      if(!_.isUndefined(this.model.get('seconds'))){
        takhfifan.eventHub.trigger('dealseconds:' + this.model.get('id'), parseInt(this.model.get('seconds')));
        takhfifan.eventHub.trigger('cartinfo:' + this.model.get('id'), this.model);

        if (this.model.get('isSoldOut')) {
          takhfifan.eventHub.trigger('buyButton:soldOut', this.model);
        }
      }
    },

    submit: function(event) {
      event.preventDefault();
      this.setAsLoading();
      this.addToCart();
      return false;
    },

    addToCart: function() {
      this.attachChildToParentProduct();
      takhfifan.eventHub.trigger('productaddtocart:' + this.model.id, this);
    },

    attachChildToParentProduct: function() {
      $.post('/ajax/product/attachparentproducttoproduct',{parentProductId : this.parentProductId, childProductId : this.model.id},function(data){
      });
    },

    disable: function() {
      this.$('.btn').attr('disabled', true);
      this.undelegateEvents();
    },

    setAsLoading: function(){
      this.$('.btn').attr('disabled', true).empty().append('<span class="spinner"></span>');
      this.undelegateEvents();
    },

    setAsDeactive: function() {
      this.$('.btn-text').empty().append('<span class="icon-cart"></span>این تخفیفان به پایان رسید');
    }

  });

});

